import React from 'react';

const logos = [
  { name: 'atomikgrow',     src: '/logos/atomikgrow.png' },
  { name: '1upautomations', src: '/logos/1upautomations.png' },
  { name: 'grovrtesting',   src: '/logos/grovrtesting.png' },
  { name: 'tenderx',        src: '/logos/tenderx.png' },
  { name: 'hinote',         src: '/logos/hinote.png' },
  { name: 'icedautomations', src: '/logos/icedautomations.png' },
  { name: 'usedibs',        src: '/logos/usedibs.png' },
];

export default function Marquee() {
  return (
    <section className="marquee-section" aria-label="Trusted by">
      <div className="container-x">
        <p className="marquee-label">Join 10+ businesses already growing with JustICP</p>
      </div>
      <div className="logo-strip" aria-hidden="false">
        <div className="logo-track">
          {/* Set 1 */}
          {logos.map((l, i) => (
            <span key={`a-${i}`} className={`logo-item${l.name === '1upautomations' ? ' logo-item--1up' : ''}`}>
              <img src={l.src} alt={`${l.name} logo`} loading="lazy" />
            </span>
          ))}
          {/* Set 2 — identical, for seamless 0 → -50% loop */}
          {logos.map((l, i) => (
            <span key={`b-${i}`} className={`logo-item${l.name === '1upautomations' ? ' logo-item--1up' : ''}`} aria-hidden="true">
              <img src={l.src} alt="" loading="lazy" />
            </span>
          ))}
        </div>
      </div>
      <p className="brand-recognition container-x">Brand recognition only, all trademarks belong to their respective owners.</p>
    </section>
  );
}
